const defaultCountry: { id: string, country: string } = {
  id: '105',
  country: 'Brasil',
};

export default defaultCountry;
